import styled from 'styled-components'
import {Box} from '@binance/uikit'
import {mediaCss as media} from '../../utils/media'

const Grid = styled(Box)`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 200px 280px 208px;
  grid-template-rows: 48px 1fr 306px;
  grid-template-areas:
    'header header header header'
    'chart depthchart orderbook tradelist'
    'history history orderform orderform';
  min-height: 572px;
  height: 100%;

  .header-mobile {
    display: none;
  }
  .graph-view-mobile {
    display: none;
  }
  
  ${media.desktop`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 200px 280px 208px;
  grid-template-rows: 48px 1fr 306px;
  grid-template-areas:
    'header header header header'
    'chart depthchart orderbook tradelist'
    'history history orderform orderform';
  min-height: 572px;
  height: 100%;

  .header-mobile {
    display: none;
  }
  .graph-view-mobile {
    display: none;
  }
  `}

  ${media.tablet`
    grid-gap: 2px;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto 280px auto auto;
    grid-template-areas:
    'header header header header header header'
    'chart chart chart chart orderbook orderbook '
    'orderform orderform orderform orderform tradelist tradelist'
    'history history history history history history ';
     height: auto;
     
  .header-pc {
    display: flex;
  }
  .header-mobile {
    display: none;
  }
  .graph-view-pc {
    display: none;
  }
  .graph-view-mobile {
    display: block;
  }
   .vertical-depth-chart {
        display: none;
      }
  `}

  ${media.phone`
    grid-gap: 2px;
    grid-template-columns: 100%;
    grid-template-rows: 170px 220px auto 209px 200px auto;
    grid-template-areas:
      'header'
      'chart'
      'orderform'
      'orderbook'
      'tradelist'
      'history';
    height: auto;

    .header-pc {
      display: none;
    }
    .header-mobile {
      display: block;
    }
    .graph-view-pc {
      display: none;
    }
    .graph-view-mobile {
      display: block;
    }
    .trade-history{
      >div:first-child{ overflow-x: scroll }
    }
    .position-tab {
      > div {
        > div:first-child {
          padding: 0 16px;
        }
      }
    }

    .vertical-depth-chart {
      display: none;
    }
  `}
`

export default Grid
